import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Controller } from '../../Controller';
import { CoverpathUtils } from '../../../../../coverpath-common/js/static/CoverpathUtils';
import { AuthenticationService } from '../../../../../coverpath-common/angular/services/authentication/authentication.service';
import { InviteErrors } from '../../../../../coverpath-common/js/interfaces/CoverpathTypes';

const INVALID_LINK_URL = '/invalid-link';
const HOME = '/home';

@Injectable()
export class ValidAdvisorLinkGuard implements CanActivate {
  controller: Controller;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    readonly amorphicService: AmorphicService
  ) {
    this.controller = amorphicService.controller as Controller;
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const advisorCode = CoverpathUtils.extractInvitationCode(route.fragment);

    if (advisorCode) {
      try {
        await this.controller.inviteController.processInviteCode(advisorCode);
      } catch (error) {
        if (error.message === InviteErrors.SESSION_COLLISION || this.controller.isLoggedIn()) {
          this.authenticationService.logout();
          return false;
        }
      }

      const application = this.controller.customer.application;
      const isApplicationDeleted = application && application.isDeleted();
      if (isApplicationDeleted) {
        this.router.navigateByUrl(INVALID_LINK_URL);
        return false;
      }
    }

    return true;
  }
}
